<template>
  <div
    v-if="!user?.is_email_verified"
    class="w-full rounded-xl py-2 pr-2 pl-3 bg-yellow mb-6 gap-2 flex items-center justify-between"
  >
    <p
      class="text-sm text-white font-medium leading-130"
      :class="{ ' py-1': !user?.is_email_verification_expired }"
    >
      {{ $t("verification_badge") }}
    </p>
    <CButton
      v-if="user?.is_email_verification_expired"
      variant="white"
      class="!w-auto !h-auto !py-2 !px-4 bg-white"
      :text="$t('go')"
      icon="icon-tick-circle text-green !leading-none h-auto  group-hover:!text-white"
      icon-position="left"
      :loading="loading"
      :disabled="loading"
      @click="sendEmailVerification()"
      main-class="font-semibold text-xs text-green group-hover:!text-white"
    />
  </div>
</template>

<script setup lang="ts">
import CButton from "@/components/Common/CButton.vue";
import { useAuthStore } from "@/modules/Auth/stores";
import { computed, ref } from "vue";
import { useCustomToast } from "@/composables/useCustomToast";
import { useI18n } from "vue-i18n";

const { showToast } = useCustomToast();
const { t } = useI18n();

const authStore = useAuthStore();
const loading = ref(false);
const user = computed(() => authStore.user);

const sendEmailVerification = () => {
  loading.value = true;
  authStore
    .userSendEmailVerification()
    .then(() => {
      authStore.fetchUserData();
      showToast(t("verified_title"), "success");
    })
    .finally(() => {
      loading.value = false;
    });
};
</script>

<style scoped></style>
